import { AlertProps } from "shared/components/Spor";

export const SemanticsList = [
  "alarm",
  "secondaryAlarm",
  "warning",
  "info",
  "success",
  "neutral",
  "system",
  "transparent",
  "transparentInverted",
] as const;

export type Semantics = (typeof SemanticsList)[number];

export type AlertVariant =
  | "error"
  | "error-secondary"
  | "important"
  | "success"
  | "info"
  | "neutral";

export const variantToSemantics = (
  variant: AlertVariant | AlertProps["variant"] | "alt" | "service",
): Semantics | undefined => {
  switch (variant) {
    case "error":
      return "alarm";
    case "error-secondary":
      return "secondaryAlarm";
    case "important":
      return "warning";
    case "success":
    case "info":
    case "neutral":
      return variant;
    case "alt":
    case "service":
    case undefined:
    default:
      return undefined;
  }
};
